import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';
import { ModalController, LoadingController, AlertController } from '@ionic/angular/lazy';
import moment from 'moment';
import { ConnectedAccountService } from 'src/app/services/connected-account.service';
import { SupportedCurrencyService } from 'src/app/services/supported-currency.service';
import { DateTimePickerPage } from 'src/app/modals/date-time-picker/date-time-picker.page';
import { StorageService } from 'src/app/services/storage.service';
import { RegisterService } from 'src/app/services/register.service';
import { UserService } from 'src/app/services/user.service';
import { Capacitor } from '@capacitor/core';

@Component({
    selector: 'app-reports-payments-and-refunds-filter',
    templateUrl: './reports-payments-and-refunds-filter.page.html',
    styleUrls: ['./reports-payments-and-refunds-filter.page.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

export class ReportsPaymentsAndRefundsFilterPage implements OnInit {
    @Input() currency_id;
    @Input() date_from;
    @Input() date_to;
    @Input() method;
    @Input() timeframe;

    filter_params = {};
    moment = moment;
    supported_currencies = null;
    formatted_date_from = null;
    formatted_date_to = null;
    date_modal_css_class = '';
    register_id = null;
    register = null;

    timeframe_options: any = { header: 'Timeframe' };
    method_options: any = { header: 'Method' };

    // modal flags
    date_picker_modal_open = false;

    constructor(
        public modalController: ModalController,
        public alertController: AlertController,
        public loadingController: LoadingController,
        private storageService: StorageService,
        private connectedAccountService: ConnectedAccountService,
        private supportedCurrencyService: SupportedCurrencyService,
        private registerService: RegisterService,
        private userService: UserService
    ) { }

    ngOnInit() {

        if(Capacitor.isNativePlatform()) {
            this.date_modal_css_class = 'backdrop';
        }

        if(this.currency_id){
            this.filter_params['currency_id'] = this.currency_id;
        }

        if(this.method) {
            this.filter_params['method'] = this.method;
        }

        if(this.timeframe) {

            this.filter_params['timeframe'] = this.timeframe;

            if(this.filter_params['timeframe'] == 'custom') {

                if(this.date_from || this.date_to) {
                    this.storageService.get("connected_account_id").then((connected_account_id) => {
                        if(connected_account_id) {
                            this.connectedAccountService.getConnectedAccount(connected_account_id).then((connected_account: any) => {
                                if(connected_account['user_id']) {
                                    this.userService.getUser(connected_account['user_id']).then((user: any) => {
                                        if(this.date_from) {
                                            this.filter_params['date_from']= this.moment.utc(this.date_from).tz(user.timezone.code).toISOString(true);
                                            this.formatted_date_from = this.moment(this.filter_params['date_from']).format("D MMM YYYY, HH:mm");
                                        }
                                        if(this.date_to) {
                                            this.filter_params['date_to'] = this.moment.utc(this.date_to).tz(user.timezone.code).toISOString(true);
                                            this.formatted_date_to = this.moment(this.filter_params['date_to']).format("D MMM YYYY, HH:mm");
                                        }
                                    });
                                }
                            });
                        }
                    });
                }

            }
        }

		this.loadSupportedCurrencies().then(() => { }).catch(() => { });

    }

    loadSupportedCurrencies() {
        return new Promise<void>((resolve, reject) => {
            this.supportedCurrencyService.getSupportedCurrencies().then((supported_currencies) => {

                if(supported_currencies) {

                    this.supported_currencies = supported_currencies;

                    this.supported_currencies.sort((a, b) => {
                        if (a['title'].toLowerCase() < b['title'].toLowerCase()) { return -1; }
                        if (a['title'].toLowerCase() > b['title'].toLowerCase()) { return 1; }
                        return 0;
                    });

                    this.storageService.get("register_id").then((register_id) => {

                        if(register_id) {
    
                            this.register_id = register_id;
    
                            this.registerService.getRegister(this.register_id).then((register) => {
    
                                if(register) {
    
                                    this.register = register;
    
                                    for(let i = 0; i < this.supported_currencies.length; i++) {

                                        // NOTE: default currency
                                        if(this.supported_currencies[i].id == this.register['location'].default_currency.id) {
                                            let register_location_default_currency = this.supported_currencies.splice(i, 1)[0];
                                            this.supported_currencies.unshift(register_location_default_currency);
                                            break;
                                        }
    
                                    }
                                }
                            })
                            .catch(() => { });
                        }
                    })
                    .catch(() => { });
                }
                resolve();
            })
            .catch(() => { 
                reject();
            });
        });
    }

    close() {
        this.modalController.dismiss();
    }

    filter() {

        let validated = true;

        if(this.filter_params["timeframe"]) {

            if(this.filter_params['timeframe'] == "today") {
                this.filter_params['date_from'] = this.moment().startOf("day").utc().format();
                this.filter_params['date_to'] = this.moment().endOf("day").utc().format();
            }
            else if(this.filter_params['timeframe'] == "yesterday") {
                this.filter_params['date_from'] = this.moment().startOf("day").subtract(1, 'days').utc().format();
                this.filter_params['date_to'] = this.moment().endOf("day").subtract(1, 'days').utc().format();
            }
            else if(this.filter_params['timeframe'] == "this_week") {
                this.filter_params['date_from'] = this.moment().startOf("isoWeek").utc().format();
                this.filter_params['date_to'] = this.moment().endOf("isoWeek").utc().format();
            }
            else if(this.filter_params['timeframe'] == "last_week") {
                this.filter_params['date_from'] = this.moment().startOf("isoWeek").subtract(1, 'weeks').utc().format();
                this.filter_params['date_to'] = this.moment().endOf("isoWeek").subtract(1, 'weeks').utc().format();
            }
            else if(this.filter_params['timeframe'] == "this_month") {
                this.filter_params['date_from'] = this.moment().startOf("month").utc().format();
                this.filter_params['date_to'] = this.moment().endOf("month").utc().format();
            }
            else if(this.filter_params['timeframe'] == "last_month") {
                this.filter_params['date_from'] = this.moment().startOf("month").subtract(1, 'months').utc().format();
                this.filter_params['date_to'] = this.moment().endOf("month").subtract(1, 'months').utc().format();
            }
            else if(this.filter_params['timeframe'] == "custom") {

                if( (this.filter_params['date_from'] == null || this.filter_params['date_from'].trim() === "") && (this.filter_params['date_to'] == null || this.filter_params['date_to'].trim() === "") ) {
                    validated = false;
                    this.presentAlert("Missing dates", "Please select a From date and/or a To date when using a Custom timeframe.");
                }
                else {
                    if(this.filter_params['date_from']) {
                        this.filter_params['date_from'] = this.moment(this.filter_params['date_from']).utc().format();
                    }
                    if(this.filter_params['date_to']) {
                        this.filter_params['date_to'] = this.moment(this.filter_params['date_to']).utc().format();
                    }
                }

            }

        }

        if(validated) {
            this.modalController.dismiss(this.filter_params);
        }

    }

    clearMethod() {
        delete this.filter_params['method'];
    }

    clearTimeframe() {

        if(this.filter_params['timeframe'] == "custom") {

            if(this.filter_params['date_from']) {
                delete this.filter_params["date_from"];
                this.formatted_date_from = null;
            }
            if(this.filter_params['date_to']) {
                delete this.filter_params["date_to"];
                this.formatted_date_to = null;
            }

        }

        delete this.filter_params['timeframe'];

    }

    async presentFromDateTimePickerModal() {
        if(!this.date_picker_modal_open) {
            this.date_picker_modal_open = true;
            const modal = await this.modalController.create({
                component: DateTimePickerPage,
                cssClass: this.date_modal_css_class,
                componentProps: {
                    date: (this.filter_params['date_from'] ? this.filter_params['date_from'] : ""),
                    format: "date-time",
                    clear_date: false
                }
            })
            modal.onDidDismiss().then((data) => {
                this.date_picker_modal_open = false;
                if(data.data) {
                    this.filter_params['date_from'] = data.data['date'];
                    this.formatted_date_from = this.moment(this.filter_params['date_from']).format("D MMM YYYY, HH:mm");
                }
            });
            return await modal.present();
        }
        else {
            return null;
        }
    }

    async presentToDateTimePickerModal() {
        if(!this.date_picker_modal_open) {
            this.date_picker_modal_open = true;
            const modal = await this.modalController.create({
                component: DateTimePickerPage,
                cssClass: this.date_modal_css_class,
                componentProps: {
                    date: (this.filter_params['date_to'] ? this.filter_params['date_to'] : ""),
                    format: "date-time",
                    clear_date: false
                }
            })
            modal.onDidDismiss().then((data) => {
                this.date_picker_modal_open = false;
                if(data.data) {
                    this.filter_params['date_to'] = data.data['date'];
                    this.formatted_date_to = this.moment(this.filter_params['date_to']).format("D MMM YYYY, HH:mm");
                }
            });
            return await modal.present();
        }
        else {
            return null;
        }
    }

    async presentAlert(header, message) {
        const alert = await this.alertController.create({
            header: header,
            message: message,
            cssClass:'alert',
            buttons: ['OK']
        });
        await alert.present();
    }

}
